import _extends from 'babel-runtime/helpers/extends';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { NavItem, NavLink } from 'reactstrap';

import { onLinkClick } from './utils';

var NAV_ITEM_DROPDOWN_CLASS = 'dropdown-item';

var NavigationItem = function (_PureComponent) {
  _inherits(NavigationItem, _PureComponent);

  function NavigationItem(props) {
    _classCallCheck(this, NavigationItem);

    var _this = _possibleConstructorReturn(this, (NavigationItem.__proto__ || Object.getPrototypeOf(NavigationItem)).call(this, props));

    _this.onItemClick = function (evt) {
      onLinkClick(evt, function () {
        var _this$props = _this.props,
            onItemClick = _this$props.onItemClick,
            item = _this$props.item;

        onItemClick(item);
      });
    };

    return _this;
  }

  _createClass(NavigationItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          item = _props.item,
          isItemActive = _props.isItemActive,
          formatItemPath = _props.formatItemPath,
          isPrimary = _props.isPrimary,
          isDropdown = _props.isDropdown,
          nested = _props.nested;
      var path = item.path,
          label = item.label,
          icon = item.icon,
          className = item.className;


      var itemClassName = isPrimary && isDropdown && nested ? NAV_ITEM_DROPDOWN_CLASS : null;

      var linkProps = {};
      var itemProps = {};
      if (isItemActive) {
        linkProps.active = isItemActive(item);
        itemProps.active = linkProps.active;
      }
      if (path !== void 0) {
        linkProps.href = formatItemPath ? formatItemPath(path) : path;
      }

      var containerClassNames = [];
      if (itemClassName) {
        containerClassNames.push(itemClassName);
      }
      if (className) {
        containerClassNames.push(className);
      }
      var containerClassName = containerClassNames.length ? containerClassNames.join(' ') : null;

      var navItem = React.createElement(
        NavItem,
        _extends({}, itemProps, { className: containerClassName }),
        React.createElement(
          NavLink,
          _extends({}, linkProps, { onClick: this.onItemClick }),
          icon,
          label
        )
      );

      return navItem;
    }
  }]);

  return NavigationItem;
}(PureComponent);

NavigationItem.propTypes = {
  item: PropTypes.object.isRequired,
  isItemActive: PropTypes.func,
  onItemClick: PropTypes.func,
  formatItemPath: PropTypes.func,
  isPrimary: PropTypes.bool,
  isDropdown: PropTypes.bool,
  nested: PropTypes.bool
};
export default NavigationItem;